import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import * as layoutActions from "../../actions/e-loketLayoutActions";
import * as exceptionActions from "../../actions/exceptionActions";
import { showToastrError } from "../../util/toastr";
import * as messages from "../../constants/ToastrConstants";
import ExceptionForm from "./ExceptionForm";
import axios from "axios";
import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";

class ExceptionPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			error: null,
			errorInfo: null
		};
	}

	componentWillUpdate(nextProps) {
		if (this.props.exception != nextProps.exception && !this.state.toastrDisplayed) {
			showToastrError(messages.MESSAGE_ERROR);
			this.setState({ toastrDisplayed: true });
			this.sendExceptionToApi(nextProps.exception);
		}
	}

	sendExceptionToApi(exception) {
		const serviceUrl = prependRoot("/tools/logerror", getApiRoot());
		return axios.put(serviceUrl,
			{
				message: (exception.message ? `Message: ${exception.message}` : exception) + (exception.stack ? `  Stack: ${exception.stack}` : "")
			},
			{
				headers: {
					accept: "application/json"
				}
			});
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error: error,
			errorInfo: errorInfo
		});
		this.sendExceptionToApi(error);
	}

	render() {
		if (this.state.error || this.props.showExceptionComponent) {
			return (
				<ExceptionForm exception={this.props.exception} reactError={this.state.error} contact={this.props.helpdeskContactLink} />
			);
		}

		return this.props.children;
	}
}

ExceptionPage.propTypes = {
	exception: PropTypes.object,
	helpdeskContactLink: PropTypes.string,
	showExceptionComponent: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	return {
		helpdeskContactLink: state.settings.helpdeskContactLink,
		exception: state.exception.exception ? state.exception.exception : null,
		showExceptionComponent: state.exception.redirectToExceptionPage ? state.exception.redirectToExceptionPage : null
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch),
		clearException: bindActionCreators(exceptionActions.clearException, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ExceptionPage);
